import React, { useState, useEffect } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { NavLink, Redirect } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Switch from "react-switch";
import { addCustomers, selectCustomer } from "../../redux/actions";

const mapStateToProps = (state) => ({
  customersList: state.customers,
  selectedCustomer: state.selectedCustomer,
});

const mapDispatchToProps = (dispatch) => ({
  addCustomers: (customers) => dispatch(addCustomers(customers)),
  selectCustomer: (customer) => dispatch(selectCustomer(customer)),
});

const Customers = ({ addCustomers, selectCustomer }) => {
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    window.server.emit("get_customers", 0, 20, (data) => {
      if (data.code === 200) {
        setCustomers(JSON.parse(data.response));
      }
      if (data.code === 404) {
        setCustomers([]);
      }
    });
  }, []);

  const cols = [
    {
      Header: "اطلاعات پایه",
      columns: [
        {
          Header: "نام",
          id: "firstName",
          accessor: (d) => d.firstName,
        },
        {
          Header: "نام خانوادگی",
          id: "lastName",
          accessor: (d) => d.lastName,
        },
      ],
    },
    {
      Header: "اطلاعات خدماتی",
      columns: [
        {
          Header: "تلفن ثابت",
          accessor: "phone",
        },
        {
          Header: "همراه",
          accessor: "call",
        },
        {
          Header: "کد اشتراک",
          accessor: "code",
        },
      ],
    },
    {
      Header: "اکشن ها",
      columns: [
        {
          Header: "مشاهده",
          accessor: "progress",
          filterable: false,
          Cell: ({ original }) => (
            <NavLink to="/info">
              <i
                onClick={() => selectCustomer(original)}
                className="view-customer"
              >
                مشاهده
              </i>
            </NavLink>
          ),
        },
        {
          Header: "بلاک",
          accessor: "isBlocked",
          filterable: false,
          Cell: ({ value }) => (
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: value ? "red" : "green",
                borderRadius: "50%",
              }}
            ></div>
          ),
        },
      ],
    },
  ];

  const handleRedirect = () => {
    setRedirect(true);
  };

  useEffect(() => handleFilterChange(filtered), [filtered]);

  const handleFilterChange = () => {
    console.log("setCustomers called");
    setFiltered(filtered || []);
    window.server.emit("filter", filtered, (data) => {
      console.log(data);
      if (data.code === 200) {
        console.log(JSON.parse(data.response)[0]);
        setCustomers(JSON.parse(data.response));
      }
      if (data.code === 404) {
        setCustomers([]);
      }
    });
  };

  const changeIsBlocked = () => {
    setIsBlocked(!isBlocked);
    setFiltered((prevFiltered) => {
      if (isBlocked) {
        return prevFiltered.filter((filter) => filter.id !== "isBlocked");
      } else {
        return [...prevFiltered, { id: "isBlocked", value: "true" }];
      }
    });
  };

  const setTableFilters = (filtered) => {
    console.log(filtered);

    if (isBlocked) filtered = [...filtered, { id: "isBlocked", value: "true" }];
    setFiltered(filtered);
  };

  if (redirect) {
    return <Redirect to="/register" />;
  }

  return (
    <div>
      <Grid fluid style={{ marginTop: "30px" }}>
        <Row>
          <Col xs={12} md={12}>
            <div
              className="title-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col xs={6} md={6} style={{ textAlign: "right" }}>
                مشتریان
              </Col>
              <Col
                xs={6}
                md={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexBasis: "max-content",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "10px" }}>فقط بلاک شده</span>
                  <Switch
                    placeholder="فقط بلاک شده"
                    onChange={changeIsBlocked}
                    checked={isBlocked}
                    onColor="#d93327"
                  />
                </div>
                <Button
                  onClick={handleRedirect}
                  bsStyle="primary"
                  style={{ marginRight: "10px" }}
                  bsSize="xsmall"
                >
                  اضافه کردن مشتری
                </Button>
              </Col>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12}>
            <ReactTable
              className="-striped -highlight"
              manual
              pages={1}
              loading={loading}
              filterable
              filtered={filtered}
              onFilteredChange={setTableFilters}
              defaultPageSize={20}
              resizable={false}
              data={customers}
              showPagination
              showPaginationBottom
              showPageSizeOptions={false}
              pageSizeOptions={[5, 10, 20, 25, 50, 100]}
              columns={cols}
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
